import { render, staticRenderFns } from "./EnforceFile.vue?vue&type=template&id=60623f05&scoped=true"
import script from "./EnforceFile.vue?vue&type=script&lang=js"
export * from "./EnforceFile.vue?vue&type=script&lang=js"
import style0 from "./EnforceFile.vue?vue&type=style&index=0&id=60623f05&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60623f05",
  null
  
)

export default component.exports